import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Typography, Button, Grid, Box } from "@mui/material";
import Footer from "./Footer";
import { getLoginCookieAndSession } from "../../utils";
import { useStripeAccountStatus } from "../../hooks/useStripeAccountStatus";
import { DrawerModal } from "./DrawerModal";
import Login from "./Login";

const MoreInfo: React.FC = () => {
  const navigate = useNavigate();
  const { sellRoute } = useStripeAccountStatus();
  const [isSellModalOpen, setSellModalOpen] = useState(false);

  const handleStartSellingClick = () => {
    if (getLoginCookieAndSession()) {
      navigate(sellRoute);
    } else {
      setSellModalOpen(true);
    }
  };

  const closeSellModal = () => setSellModalOpen(false);

  return (
    <Box
      sx={{
        maxWidth: "450px",
        margin: "0 auto",
        mb: 3,
        textAlign: "center",
        px: 2,
      }}
    >
      {/* Logo */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mt: 2,
          mb: 3,
        }}
      >
        <img
          src="/logoicon.png"
          alt="Logo Icon"
          style={{ marginRight: "10px", height: "40px" }}
        />
        <img src="/logo512.png" alt="Logo" style={{ height: "30px" }} />
      </Box>

      {/* Intro Text */}
      <Typography variant="body1" sx={{ mb: 2, color: "#333" }}>
        Welcome, <span style={{ color: "#e78758" }}>FiddlePiddle</span> is a
        global online toy marketplace, where people come together to sell, buy,
        and collect toys.
      </Typography>

      {/* Features */}
      <Grid container spacing={2} sx={{ maxWidth: "350px", mx: "auto" }}>
        {renderColumn("For Buyers", [
          "Rare Finds",
          "Simple Checkout",
          "Trusted Sellers",
        ])}
        {renderColumn("For Sellers", [
          "Free to List",
          "Pay Only if It Sells",
          "Fast Setup",
        ])}
      </Grid>

      {/* CTA Button */}
      <Button
        variant="contained"
        color="primary"
        onClick={handleStartSellingClick}
        sx={{
          mt: 3,
          borderRadius: "20px",
          width: "200px",
          color: "white",
          lineHeight: "unset",
        }}
      >
        Start Selling Now
      </Button>

      <Footer />

      <DrawerModal
        isOpen={isSellModalOpen}
        onClose={closeSellModal}
        anchor="bottom"
        onOpen={handleStartSellingClick}
      >
        <Login openFormFrom={"Seller"} />
      </DrawerModal>
    </Box>
  );
};

// Feature column helper
const renderColumn = (
  title: string,
  items: string[],
  titleFontSize = "1rem",
  itemsFontSize = "0.8rem"
) => (
  <Grid item xs={6} sx={{ textAlign: "center" }}>
    <Typography
      variant="h6"
      sx={{ fontSize: titleFontSize, color: "#e78758", mb: 1 }}
    >
      {title}
    </Typography>
    {items.map((item, index) => (
      <Typography
        key={index}
        sx={{ textAlign: "left", fontSize: itemsFontSize, color: "#333" }}
      >
        ✔️ {item}
      </Typography>
    ))}
  </Grid>
);

export default MoreInfo;
